var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPv0HendikepovaniWebLoga512X512PxSkoda(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Vrstva_1",
    "data-name": "Vrstva 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m11.51,290.23l9.06-14.49h52.54c2.98,0,4.92-1.94,4.92-4.92v-8.41h-45.16c-13.46,0-19.41-5.95-19.41-19.15v-5.69c0-9.84,5.82-15.79,15.01-15.79h1.04v21.22c0,2.98,1.94,4.92,4.92,4.92h43.74c9.96,0,15.92,5.95,15.92,15.66v7.51c0,12.81-6.34,19.15-19.41,19.15H11.51Zm314.84-14.75h40.63c6.73,0,11-4.14,11-10.61v-17.73c0-6.47-4.27-10.61-11-10.61h-40.63v38.95Zm-16.31,14.75v-68.46h57.33c17.08,0,26.92,9.84,26.92,26.14v16.18c0,16.31-9.84,26.14-26.92,26.14h-57.33Zm-79.02-14.75h34.29c6.21,0,10.22-3.88,10.22-9.96v-19.02c0-6.08-4.01-9.96-10.22-9.96h-34.29c-6.21,0-10.22,3.88-10.22,9.96v19.02c0,6.08,4.01,9.96,10.22,9.96Zm34.68,14.75h-35.07c-16.56,0-26.14-9.58-26.14-25.49v-17.47c0-15.92,9.58-25.49,26.14-25.49h35.07c16.56,0,26.14,9.58,26.14,25.49v17.47c0,15.92-9.58,25.49-26.14,25.49Zm135.26,0l38.43-68.46h22.65l38.43,68.46h-18.63l-6.6-11.78h-32.74l-8.8-13.98-14.49,25.75h-18.25Zm33.13-26.53h32.87l-16.44-29.12-16.44,29.12Zm-388.56-27.69l-9.32-14.24h56.29l-9.06,14.24h-37.92Zm66.47,54.22v-68.46h16.31v26.66h21.61l28.08-26.66h21.61l-35.72,34.03,36.36,34.42h-22.91l-28.08-27.05h-20.96v27.05h-16.31Z",
    fill: "#fff",
    strokeWidth: 0
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPv0HendikepovaniWebLoga512X512PxSkoda);
export default __webpack_public_path__ + "static/media/PV0-Hendikepovani-web-loga-512x512px-SKODA.9de1c13f3180d2eab92dcb7c047831a3.svg";
export { ForwardRef as ReactComponent };